import React from "react";
import { getTranslation } from "../../utils/translate.js";
import { useLanguage } from "../../utils/languageContext.js";

/** Segments inside “Ongoing orders”: list vs kitchen (dish aggregation). */
const OngoingSubTabs = ({ ongoingSubTab, onChange }) => {
    const { language } = useLanguage();

    return (
        <div className="w-full max-w-xl bg-white dark:bg-[#161b22] rounded-lg p-1 shadow-inner border dark:border-[#30363d]">
            <div className="relative flex min-h-[2.5rem]">
                <button
                    type="button"
                    className={`relative flex-1 z-10 rounded-md px-3 py-2 text-xs sm:text-sm font-semibold transition-colors ${
                        ongoingSubTab === "orders"
                            ? "text-gray-900 dark:text-[#c9d1d9]"
                            : "text-gray-600 dark:text-[#8b949e] hover:text-gray-900 dark:hover:text-[#c9d1d9]"
                    }`}
                    onClick={() => onChange("orders")}
                >
                    {getTranslation("orderPage.ongoingSubOrders", language)}
                </button>
                <button
                    type="button"
                    className={`relative flex-1 z-10 rounded-md px-3 py-2 text-xs sm:text-sm font-semibold transition-colors ${
                        ongoingSubTab === "dishes"
                            ? "text-gray-900 dark:text-[#c9d1d9]"
                            : "text-gray-600 dark:text-[#8b949e] hover:text-gray-900 dark:hover:text-[#c9d1d9]"
                    }`}
                    onClick={() => onChange("dishes")}
                >
                    {getTranslation("orderPage.ongoingSubDishes", language)}
                </button>
                <div
                    className="absolute left-0 top-0 bottom-0 w-1/2 bg-gray-100 dark:bg-[#21262d] rounded-md border border-gray-200/80 dark:border-[#30363d] pointer-events-none transition-transform duration-200 ease-out"
                    style={{
                        transform: ongoingSubTab === "dishes" ? "translateX(100%)" : "translateX(0)"
                    }}
                />
            </div>
        </div>
    );
};

export default OngoingSubTabs;
